import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { LANGUAGES } from '../../i18n';
import './LanguageSwitcher.css';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // i18n.language may be 'fr-FR' while our codes are 'fr' — use resolvedLanguage or prefix match
  const resolvedCode = i18n.resolvedLanguage || i18n.language;
  const currentLang = LANGUAGES.find(l => l.code === resolvedCode)
    || LANGUAGES.find(l => i18n.language.startsWith(l.code))
    || LANGUAGES[0];

  useEffect(() => {
    if (!open) return;
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const changeLanguage = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="lang-switcher" ref={ref}>
      <button
        className="lang-switcher-btn"
        onClick={() => setOpen(!open)}
        title={currentLang.nativeName}
      >
        <img src={currentLang.flag} alt="" className="lang-switcher-flag" />
        <span className="lang-switcher-code">{currentLang.code.toUpperCase()}</span>
      </button>

      {open && (
        <div className="lang-switcher-menu">
          <div className="lang-switcher-header">
            <Globe size={14} />
            <span>Language</span>
          </div>
          <div className="lang-switcher-list">
            {LANGUAGES.map(lang => (
              <button
                key={lang.code}
                className={`lang-switcher-option ${lang.code === resolvedCode || i18n.language.startsWith(lang.code) ? 'active' : ''}`}
                onClick={() => changeLanguage(lang.code)}
              >
                <img src={lang.flag} alt="" className="lang-switcher-option-flag" />
                <span className="lang-switcher-option-native">{lang.nativeName}</span>
                <span className="lang-switcher-option-name">{lang.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher;
